import { isNil } from '@lucidlink/tscore';
import { NotFoundError } from '#filesystem/types';
export const createFileNodeManagerMock = (blockSize) => {
    return new FileNodeManagerMock(blockSize);
};
class FileNodeManagerMock {
    fileSizes;
    constructor(blockSize) {
        this.fileSizes = {
            '1:1': BigInt(blockSize),
            '1:2': BigInt(blockSize),
            '1:3': BigInt(30),
            '1:4': BigInt(3 * blockSize),
            '1:5': BigInt(3 * blockSize + 100),
            '1:6': BigInt(3 * blockSize),
            '1:7': BigInt(3 * blockSize + 10),
            '1:8': BigInt(2 * blockSize + 50),
            '1:9': BigInt(12 * blockSize),
            '1:10': BigInt(3_000 * blockSize),
        };
    }
    getGlobalMetaValue(_inodeId) {
        return Promise.resolve(new Uint8Array());
    }
    getLayoutKeyRange(_inodeId) {
        return Promise.resolve([]);
    }
    invalidateCache(_inodeId) { }
    stop() { }
    getSize(inodeId) {
        const size = this.fileSizes[inodeId];
        if (isNil(size)) {
            return Promise.reject(new NotFoundError());
        }
        return Promise.resolve(size);
    }
    async getMetadata(inodeId) {
        return Promise.resolve({
            size: await this.getSize(inodeId),
            creationTime: 0n,
            updateTime: 0n,
        });
    }
}
